module.exports = __webpack_public_path__ + "preset.0d5e1fd94b784f2c65a32e4c4e0a1710.png";